<template>
  <div>
    <vxe-grid
      ref="techTable"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      size="mini"
      resizable
      border
      :edit-rules="validRules"
    >
      <template v-slot:top>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      validRules: {
        techChargeUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        labourCost: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    remove(row) {
      this.$refs.techTable.remove(row)
    },
    async validate() {
      // 校验重复数据
      const tableData = await this.getTableData()
      if (tableData && tableData.length) {
        const keys = tableData.map(
          (item) => `${item.v_pdProcessDictStep}-${item.techName}`
        )

        const reKeys = keys.filter(
          (i) => keys.indexOf(i) !== keys.lastIndexOf(i)
        )
        if (reKeys && reKeys.length) {
          this.$message.error(
            `${this.$l('tips_input_techRepeat') ||
              '存在重复的工艺，请检查。'}[${reKeys[0]}]`
          )
          return false
        }
      }

      return !(await this.$refs.techTable.validate(true))
    },
    async getTableData() {
      const { tableData } = this.$refs.techTable.getTableData()
      return tableData || []
    },
    async insert(records) {
      return await this.$refs.techTable.insert(records)
    },
    async setActiveCell(row, fieldOrColumn) {
      await this.$refs.techTable.setActiveCell(row, fieldOrColumn)
    },
  },
}
</script>
